import { useTranslation } from "react-i18next";
import Checkbox from "../../../../../components/shared/inputs/Checkbox";
import Form from "../../../../../components/shared/Form";
import Tooltip from "../../../../../components/shared/Tooltip";

interface OptionsField {
    name: string;
    label: string;
    disabled?: boolean;
}

function OptionsTable({ fields, header }: { fields: OptionsField[]; header?: string }) {
    const { t } = useTranslation();

    return (
        <table className="tw-w-full tw-text-sm">
            <thead>
                <tr className="tw-text-left tw-text-xs tw-text-gray-400">
                    <th className="tw-pb-1 tw-font-normal tw-w-full"></th>
                    <th className="tw-pb-1 tw-font-normal tw-text-center tw-px-2 tw-whitespace-nowrap">{header ?? t("hide")}</th>
                </tr>
            </thead>
            <tbody>
                {fields.map((field) => (
                    <tr key={field.name}>
                        <td className="tw-py-1 tw-text-gray-700">{field.label}</td>
                        <td className="tw-py-1 tw-px-2">
                            <div className="tw-flex tw-justify-center">
                                <Tooltip
                                    trigger={(
                                        <span className="tw-inline-flex">
                                            <Form.Field name={field.name} valuePropName="checked" className="tw-mb-0" shouldUnregister={false}>
                                                <Checkbox disabled={field.disabled} />
                                            </Form.Field>
                                        </span>
                                    )}
                                >
                                    {field.label}
                                </Tooltip>
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default OptionsTable;
